import { FC } from "react";

type IProps = {
  width?: string;
  height?: string;
};

const PlayMain: FC<IProps> = ({ width, height }) => {
  return (
    <svg
      width={width ? width : "56"}
      height={height ? height : "56"}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_532_5398)">
        <circle cx="28" cy="28" r="26" fill="#FD8533" />
        <rect x="8" y="8" width="40" height="40" rx="20" fill="white" />
        <path
          d="M34 26.8037C35.0667 27.4243 35.0667 28.9757 34 29.5963L24.4 35.1816C23.3333 35.8022 22 35.0264 22 33.7853L22 22.6147C22 21.3736 23.3333 20.5978 24.4 21.2184L34 26.8037Z"
          fill="#FD8533"
        />
      </g>
      <defs>
        <clipPath id="clip0_532_5398">
          <rect width="56" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PlayMain;
